<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    :width="width"
    :height="height"
  >
    <path d="M28 16.0004C28.0001 18.8259 27.0032 21.5609 25.1849 23.7236C23.3665 25.8863 20.8433 27.3379 18.0597 27.8229C15.2761 28.3079 12.4106 27.7951 9.96801 26.3748C7.52539 24.9545 5.66229 22.7178 4.70686 20.0587C3.75142 17.3996 3.76495 14.4886 4.74505 11.8385C5.72516 9.18842 7.60897 6.96916 10.0647 5.57162C12.5204 4.17408 15.3905 3.68791 18.1695 4.19874C20.9485 4.70957 23.4581 6.18464 25.2563 8.36413C25.3455 8.46457 25.4136 8.58198 25.4565 8.70934C25.4994 8.8367 25.5162 8.9714 25.5058 9.10538C25.4955 9.23937 25.4582 9.36989 25.3963 9.48917C25.3344 9.60844 25.2491 9.714 25.1455 9.79956C25.0418 9.88512 24.922 9.94891 24.7932 9.98713C24.6643 10.0254 24.5291 10.0372 24.3956 10.022C24.2621 10.0068 24.133 9.96483 24.0161 9.89861C23.8991 9.8324 23.7967 9.7433 23.715 9.63663C22.2442 7.85327 20.201 6.63455 17.933 6.18777C15.665 5.74099 13.3122 6.09376 11.275 7.18606C9.23769 8.27837 7.64178 10.0427 6.7587 12.179C5.87562 14.3153 5.75992 16.6916 6.43128 18.9035C7.10265 21.1155 8.51961 23.0266 10.4411 24.3116C12.3626 25.5967 14.67 26.1763 16.9707 25.952C19.2714 25.7277 21.4233 24.7132 23.0604 23.0812C24.6975 21.4492 25.7186 19.3004 25.95 17.0004H16C15.7348 17.0004 15.4804 16.895 15.2929 16.7075C15.1054 16.5199 15 16.2656 15 16.0004C15 15.7352 15.1054 15.4808 15.2929 15.2933C15.4804 15.1057 15.7348 15.0004 16 15.0004H27C27.2652 15.0004 27.5196 15.1057 27.7071 15.2933C27.8946 15.4808 28 15.7352 28 16.0004Z" />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 32,
    },
    height: {
      type: [Number, String],
      default: 32,
    },
  },
}
</script>

